import { z } from 'zod';
import superjson from 'superjson';

export const schema = z.object({
  sessionId: z.string().min(1),
});

export type InputType = z.infer<typeof schema>;

export type ChatAttachmentUser = {
  id: number;
  displayName: string;
  avatarUrl: string | null;
};

export type ChatAttachmentItem = {
  id: string;
  fileName: string;
  fileType: string | null;
  fileSize: number | null;
  dataUrl: string;
  isPrivate: boolean;
  shareToken: string | null;
  sharedWith: string | null;
  createdAt: string | null;
  sessionId: string;
  uploadedBy: ChatAttachmentUser;
};

export type OutputType = {
  attachments: ChatAttachmentItem[];
};

export const getChatAttachmentsList = async (
  input: InputType,
  init?: RequestInit,
): Promise<OutputType> => {
  const params = new URLSearchParams({ sessionId: input.sessionId });
  const result = await fetch(`/_api/chat-attachments/list?${params.toString()}`, {
    method: 'GET',
    credentials: 'include',
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers ?? {}),
    },
  });
  if (!result.ok) {
    const errorObject = superjson.parse<{ error: string }>(await result.text());
    throw new Error(errorObject.error);
  }
  return superjson.parse<OutputType>(await result.text());
};
